import React, { useEffect, useRef, useState } from 'react';
import { Grid, Button, Box, useTheme } from '@mui/material';

import CancellationPolicies from '../CancellationPolicies';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

import { sxStyle } from './styles';
import CommentsSection from './CommentsSection';
import { dedupeGroupedComments, getGeneralComments } from './helpers';

const Remarks = ({
  setSeeMore,
  room,
  hotelsValidateResult,
  buttonClose = true,
  preview = false,
  seeTitle = false,
  cancelationFee,
}) => {
  const contentRef = useRef(null);
  const [hasOverflow, setHasOverflow] = useState(false);
  const [expanded, setExpanded] = useState(false);

  const theme = useTheme();

  const MAX_HEIGHT = 120;

  const isExpanded = !preview || expanded;

  useEffect(() => {
    if (preview && contentRef.current) {
      const el = contentRef.current;
      setHasOverflow(el.scrollHeight > el.clientHeight);
    }
  }, [preview, room, hotelsValidateResult]);

  const [general_comments, remarks, comments] = dedupeGroupedComments([
    getGeneralComments(room, cancelationFee),
    hotelsValidateResult?.remarks || [],
    hotelsValidateResult?.comments || [],
  ]);

  return (
    <Grid container direction="column">
      <Grid item xs={12}>
        <div
          ref={contentRef}
          style={{
            maxHeight: isExpanded ? 'none' : `${MAX_HEIGHT}px`,
            overflow: isExpanded ? 'visible' : 'hidden',
            position: 'relative',
          }}
        >
          <CommentsSection
            title="Observaciones generales"
            items={general_comments}
            sectionKey="general-comment"
            seeTitle={seeTitle}
          />

          <CancellationPolicies hotelsValidateResult={hotelsValidateResult} />

          <CommentsSection
            title="Observaciones"
            items={remarks}
            sectionKey="hotel-remark"
            seeTitle={seeTitle}
            marginTop={2}
          />

          <CommentsSection
            title="Comentarios"
            items={comments}
            sectionKey="hotel-comment"
            seeTitle={seeTitle}
            marginTop={2}
          />

          {/* fade visual */}
          {preview && hasOverflow && !expanded && (
            <div
              style={{
                position: 'absolute',
                bottom: 0,
                height: '20px',
                width: '100%',
                background: 'linear-gradient(transparent, white)',
              }}
            />
          )}
        </div>
      </Grid>

      {/* Ver más / menos */}
      {preview && hasOverflow && (
        <Box
          sx={{
            mt: '2vh',
            cursor: 'pointer',
            display: 'flex',
            color: theme?.tertiary,
            fontSize: '15px',
            fontFamily: 'Open Sans, sans-serif',
          }}
          onClick={() => setExpanded(prev => !prev)}
        >
          {expanded ? 'Ver menos' : 'Ver más'}

          {expanded ? (
            <ExpandLessIcon sx={{ ml: '0.2vw', mt: '-1px' }} />
          ) : (
            <ExpandMoreIcon sx={{ ml: '0.2vw', mt: '-1px' }} />
          )}
        </Box>
      )}

      {/* botón cerrar */}
      {buttonClose && (
        <Grid
          item
          xs={12}
          sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}
        >
          <Button
            id="ver-menos-boton"
            sx={sxStyle.seeLess}
            onClick={() => setSeeMore?.(false)}
          >
            Cerrar
          </Button>
        </Grid>
      )}
    </Grid>
  );
};

export default Remarks;
